export const CAPABILITY_LOADED_SUCCESS = 'CAPABILITY_LOADED_SUCCESS';
export const CAPABILITY_LOADED_FAILURE = 'CAPABILITY_LOADED_FAILURE';
export const SYSTEM_CAPABILITY_LOADED_SUCCESS = 'SYSTEM_CAPABILITY_LOADED_SUCCESS';
export const SUPPORTED_LANGUAGES_LOADED_SUCCESS = 'SUPPORTED_LANGUAGES_LOADED_SUCCESS';
export const SUPPORTED_LANGUAGES_LOADED_FAILURE = 'SUPPORTED_LANGUAGES_LOADED_FAILURE';
